import React from 'react'
import Lottie from 'react-lottie'

import PropTypes from 'prop-types'

import Spinner from '@galo-monitor/styles/assets/animations/spinner.json'

import { Container, Message } from './styles'

const lottieStyle = {
  height: '100%',
  alignSelf: 'center'
}

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: Spinner
}

function AnimatedLoader({ message, width }) {
  return (
    <Container>
      <Lottie options={ defaultOptions } isClickToPauseDisabled style={ lottieStyle } width={ width }/>
      {message && <Message>{message}</Message>}
    </Container>
  )
}

AnimatedLoader.propTypes = {
  message: PropTypes.string,
  width: PropTypes.number
}

AnimatedLoader.defaultProps = {
  message: null,
  width: 200
}


export default AnimatedLoader
